import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { resetAuth } from "store/auth";
import { resetBank } from "store/bank";
import { resetDeposit } from "store/deposit";
import { resetUser } from "store/user";

import { useAppDispatch } from "./app-hook";

export const useLogout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return useCallback(() => {
    dispatch(resetAuth());
    dispatch(resetBank());
    dispatch(resetDeposit());
    dispatch(resetUser());
    navigate("/");
    localStorage.clear();
  }, []);
};
